import React from 'react';
import { Link } from 'react-router-dom';
import {
  Card,
  CardBody,
  CardTitle,
  Row,
  Col,
  Form,
  FormGroup,
  Label,
  Input,
  FormText,
  Button,
  Alert,
} from 'reactstrap';
import Select, { components } from "react-select";
import jQuery from 'jquery'

import { getCurrentUser, authenticateLoggedIn, addHeaderTitle, getParameterByName, authenticateLoginpage, addBreadcrumb } from '../../services/parse';
import { updateRecord, checkFieldValid, fetchRecordById } from '../../services/emailtemplate';
import withRouter from '../../components/common/WithRouter';

class editEmailTemplate extends React.Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      tooltipOpen: false,
      collapse: true,
      fadeIn: true,
      timeout: 300,
      isSuper: '',
      addedclass: 'd-none',
      recordByIdData: [],
      isEdit: false,
      logofile: null,
      rewardsfile: null,
      loginlogofile: null,
    };
  }


  async componentDidMount(evt) {
    //auth start
    authenticateLoggedIn();
    addHeaderTitle('Edit Email Template');
    addBreadcrumb('Home / Email Template / Edit Template');

    // var editobjectid = getParameterByName('objectid');
    var editobjectid = this.props.params.objectid;

    if (editobjectid) {
      fetchRecordById({ objectid: editobjectid }).then((value) => {
        if (value.length > 0) {
          this.setState({ recordByIdData: value[0] });
          this.setState({ isEdit: true });


        } else {
          this.setState({ isEdit: false });
        }
      });

    }

  }

  toggle() {
    this.setState({
      tooltipOpen: !this.state.tooltipOpen
    });
  }


  updateRecord = () => {

    var valid = checkFieldValid('add');
    if (valid !== false) {
      jQuery('#addbutton').prop('disabled', true);

      var hiddenrecordid = jQuery('#hiddenrecordid').val();
      var name = jQuery('#bname').val();
      var subject = jQuery('#subject').val();
      var htmldata = jQuery('#htmldata').val();
      var toemail = jQuery('#toemail').val();
      var status = jQuery('#status').val();

      var fielddatas = {
        edithiddenid: hiddenrecordid,
        name: name,
        subject: subject,
        htmldata: htmldata,
        toemail: toemail,
        status: status,
      };

      updateRecord(fielddatas).then((value) => {
        if (value === true) {
          this.setState({ addedclass: 'd-block' });
        } else {
          this.setState({ addedclass: 'd-none' });
        }

        jQuery('#addform').trigger("reset");
        jQuery('#addbutton').prop('disabled', false);
      });

    }
  }





  render() {
    return <div>

      {this.state.isEdit === true ?
        <div>
          <Row className="justify-content-between topbuttonbar">
            <Col className="col-md-5">
              <Alert color="success" className={this.state.addedclass}>
                Record Updated
                  <Link to="/emailtemplate/emailtemplate" className="float-right">
                  &nbsp; Go to list
                  </Link>
              </Alert>
            </Col>
            <Col className="col-auto mb-4">
              <Link to="/emailtemplate/emailtemplate" className="btn btn-primary btncancle mr-3">
                <span className="border-left pl-2">Cancel</span>
              </Link>
              <Button type="button" color="primary" id="addbutton" onClick={this.updateRecord}>
                <span className="border-left pl-2"></span>
                Save
              </Button>
            </Col>
          </Row>
          <Row>

            <Col md="5">
              <Card>
                <CardTitle>
                  <i className="icon-circle icon-pencil"></i>
                  Edit Template
                </CardTitle>
                <CardBody>

                  <Form id="addform">
                    <Input type="hidden" id="hiddenrecordid" defaultValue={this.state.recordByIdData.id} />
                    <FormGroup className="form-group">
                      <Label htmlFor="name">Name</Label>
                      <Input type="text" name="bname" id="bname" defaultValue={this.state.recordByIdData.get('name')} />
                    </FormGroup>

                    <FormGroup className="form-group">
                      <Label htmlFor="name">Subject</Label>
                      <Input type="text" name="subject" id="subject" defaultValue={this.state.recordByIdData.get('subject')} />
                    </FormGroup>

                    <FormGroup className="form-group">
                      <Label htmlFor="description">HTML</Label>
                      <Input type="textarea" name="htmldata" id="htmldata" rows="8" placeholder="Add your template" defaultValue={this.state.recordByIdData.get('html')} />
                    </FormGroup>

                    <FormGroup className="form-group">
                      <Label htmlFor="name">To Email</Label>
                      <Input type="text" name="toemail" id="toemail" defaultValue={this.state.recordByIdData.get('toEmail')} />
                    </FormGroup>



                    <FormGroup className="form-group">
                      <Label htmlFor="country">Status</Label>
                      <select name="status" id="status" className="form-control" defaultValue={String(this.state.recordByIdData.get('status'))}>
                        <option value="true">Active</option>
                        <option value="false">Inactive</option>
                      </select>
                    </FormGroup>




                  </Form>
                </CardBody>
              </Card>
            </Col>





            <Col md="7">
              <Card>
                <CardBody>
                  <FormGroup className="form-group">
                    <div dangerouslySetInnerHTML={{ __html: this.state.recordByIdData.get('html') }} />
                  </FormGroup>
                </CardBody>
              </Card>
            </Col>





          </Row>
        </div>
        :
        <p></p>
      }

    </div>
  }
}

export default withRouter(editEmailTemplate);
